import { Badge } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";

interface RecordStatusBadgeProps {
  status: string | null;
}

export const RecordStatusBadge = ({ status }: RecordStatusBadgeProps) => {
  const { t } = useTranslation();
  if (!status) return null;

  const statusColors: Record<string, { className: string, label: string }> = {
    "complete": {
      className: "bg-green-100 text-green-800 hover:bg-green-100 border-green-200",
      label: t('records.status.completed')
    },
    "completed": {
      className: "bg-green-100 text-green-800 hover:bg-green-100 border-green-200",
      label: t('records.status.completed')
    },
    "error": {
      className: "bg-red-100 text-red-800 hover:bg-red-100 border-red-200",
      label: t('records.status.failed')
    },
    "failed": {
      className: "bg-red-100 text-red-800 hover:bg-red-100 border-red-200",
      label: t('records.status.failed')
    },
    "processing": {
      className: "bg-blue-100 text-blue-800 hover:bg-blue-100 border-blue-200",
      label: t('records.status.processing')
    },
    "queued": {
      className: "bg-yellow-100 text-yellow-800 hover:bg-yellow-100 border-yellow-200",
      label: t('records.status.queued')
    },
    "pending": {
      className: "bg-purple-100 text-purple-800 hover:bg-purple-100 border-purple-200",
      label: t('records.status.waiting')
    },
    "waiting": {
      className: "bg-orange-100 text-orange-800 hover:bg-orange-100 border-orange-200",
      label: t('records.status.waiting')
    }
  };

  const statusInfo = statusColors[status.toLowerCase()] || {
    className: "bg-muted text-foreground hover:bg-muted border-border",
    label: t('records.status.unknown')
  };

  return (
    <Badge
      className={`font-medium ${statusInfo.className} shadow-sm px-3 py-1`}
      variant="outline"
    >
      {statusInfo.label}
    </Badge>
  );
};
